import React, { useRef, useState } from 'react';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import CloseIcon from '@mui/icons-material/Close';
import Fab from '@mui/material/Fab';
import { Stack } from '@mui/system';
import { Camera as CameraPro } from "react-camera-pro";
import BigTitle from './BigTitle';
import { editImageInput } from '../store/forms';
import { useDispatch, useSelector } from 'react-redux';
import { handleImage } from '../helper';
import Theme from './Theme';
import usePersonalDocuments from '../hooks/usePersonalDocuments';
import { getCameraModeSelector, setCameraMode } from '../store/camera';
import { useThemeCustomStyles } from '../hooks/useThemeConfig';

  
function Camera({ children }) {
  const [numberOfCameras, setNumberOfCameras] = useState(0);

  const dispatch = useDispatch();
  const cameraMode = useSelector(getCameraModeSelector);


  const { nextFile, selectedFile, setSelectedFile, title } = usePersonalDocuments();

  const view = "checkin2";
	const object = "files";
  const handleChangeValue = (id, value, size) => {
		dispatch(editImageInput({ data: value, object, input: id, view, size, source: 'user' }));
		//setActualTab(id);
	};
	const handleChange = (id, event) => {
		const { size, data } = event;
		handleChangeValue(id, data, size);
	};

  const DataURIToBlob = (dataURI) => {
    const splitDataURI = dataURI.split(',');
    const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1]);
    const mimeString = splitDataURI[0].split(':')[1].split(';')[0];

    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) 
        ia[i] = byteString.charCodeAt(i);

    return new Blob([ia], { type: mimeString });
  };  

  const camera = useRef(null);
  
  const handleTakePhoto = () => {
    if(numberOfCameras > 0){
      const base64Photo = camera.current.takePhoto();
      const blobPhoto = DataURIToBlob(base64Photo);
      const name = selectedFile+".jpeg";
      const filePhoto = new File([blobPhoto], name, {lastModified: new Date()});
      /*const objectToSave = {
        data: blobPhoto, size
      };*/
      const saveMethod = (objectToSave) => handleChange(selectedFile, objectToSave);
      handleImage(filePhoto, saveMethod);

      if (nextFile !== '') {
        setSelectedFile(nextFile);
      } else {
        dispatch(setCameraMode(false));
      }
    }
  }

  
  const styles = useThemeCustomStyles();

  const fabStyle = styles.Camara.fabStyle;
  const closeFabStyle = styles.Camara.closeFabStyle;
  const containerTextStyle = styles.Camara.containerTextStyle;
  const textStyle = styles.Camara.textStyle;

  return cameraMode ? 
  (<Theme><Stack direction="column">
      <CameraPro ref={camera} facingMode="environment" aspectRatio="cover" numberOfCamerasCallback={setNumberOfCameras}/>
        <BigTitle text={title} bar={false} textSx={textStyle} containerSx={containerTextStyle} paper={true}/>
    <Fab sx={fabStyle} size="large" color="primary" aria-label="Tomar foto" onClick={handleTakePhoto}>
      <PhotoCameraIcon />
    </Fab>
    <Fab sx={closeFabStyle} size="large" color="primary" aria-label="Cerrar camara foto" onClick={() => dispatch(setCameraMode(false))}>
      <CloseIcon />
    </Fab>
  </Stack></Theme>) : children;
}

export default Camera;